<template>
  <a-typography-text>{{ preview }}
    <a-button size="small" type="link" :icon="h(EditOutlined)" @click="onTitleEditShow"/>
  </a-typography-text>
  <a-modal :title="title ?? '编辑标题'" v-model:open="info.title.open" @ok="onTitleChange" width="720px"
           destroy-on-close>
    <a-flex vertical gap="middle" style="padding-top: 12px">
      <a-textarea v-model:value="info.title.tpl" autofocus/>
      <a-spin :spinning="info.title.variableLoading">
        <a-flex gap="small" wrap="wrap">
          添加变量：
          <a-button v-for="v in info.title.variables" :key="v" size="small"
                    :type="info.title.tpl.includes(v) ? 'primary' : 'default'" :ghost="info.title.tpl.includes(v)"
                    @click="info.title.tpl+=`<${v}>`">
            {{ v }}
          </a-button>
        </a-flex>
      </a-spin>
      <a-menu v-if="templates.length>0" :items="templates.map(t => ({key:t,label:t}))"
              @click="(evt:any) => info.title.tpl = evt.key"/>
    </a-flex>
  </a-modal>

</template>

<script setup lang="ts">

import {h, reactive, watch} from "vue";
import {EditOutlined} from "@ant-design/icons-vue";
import {useRoute} from "vue-router";
import {AEditor} from "@/views/editor/service/editor";

const route = useRoute()
const editor = route.meta.editor as AEditor;
const props = defineProps<{
  template: string,
  templates: string[],
  title?: string,
  preview?: string,
}>()
const emit = defineEmits(["update", 'preview'])
const info = reactive({
  tpl: props.template,
  title: {
    open: false,
    tpl: props.template,
    variableLoading: false,
    variables: [] as string[],
  },
})

watch(() => editor.active.preview.branch_id, () => {
  editor.titlePreview(info.title.tpl).then(t => {
    info.title.open = false
    emit('update', info.title.tpl)
    emit('preview', t)
  })
})

const onTitleEditShow = () => {
  info.title.open = true
  if (info.title.variables.length == 0) {
    info.title.variableLoading = true
    editor.titleVariables().then((value) => {
      info.title.variables = value
    }).finally(() => info.title.variableLoading = false)
  }
}

const onTitleChange = () => {
  editor.titlePreview(info.title.tpl).then(t => {
    info.title.open = false
    emit('update', info.title.tpl)
    emit('preview', t)
  })
}

</script>

<style scoped lang="sass">

</style>